import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface SelectedTabStore {
  selectedTab: number
  setSelectedTab: (index: number) => void
}

export const createSelectedTabStore = (storage: StateStorage) =>
  createStore<SelectedTabStore>(
    storage,
    (set) => ({
      selectedTab: 0,
      setSelectedTab(index) {
        set({ selectedTab: index })
      },
    }),
    {
      persist: {
        name: 'selectedTab',
      },
    }
  )
